/**
 * 创建一个cookie
 * @param {String} name cookie 名称
 * @param {String} value cookie 值
 * @param {String} path cookie 路径
 * @param {String} domain cookie 域
 * @param {Number} expires cookie 过期时间，毫秒数
 * @param {String} secure 安全
 */
const set = function set(name, value, path, domain, expires, secure) {
    const cStrArr = [];

    cStrArr.push(`${name}=${encodeURIComponent(value)}`);

    if (expires) {
        const date = new Date();

        date.setTime(date.getTime() + expires);
        cStrArr.push(`;expires=${date.toGMTString()}`);
    }
    cStrArr.push(path ? `; path=${path}` : '');
    cStrArr.push(domain ? `; domain=${domain}` : '');
    cStrArr.push(secure ? '; secure' : '');

    document.cookie = cStrArr.join('');
};

const setByEscape = function setByEscape(name, value, path, domain, expires, secure) {
    const cStrArr = [];

    cStrArr.push(`${name}=${escape(value)}`);

    if (expires) {
        const date = new Date();

        date.setTime(date.getTime() + expires);
        cStrArr.push(`;expires=${date.toGMTString()}`);
    }
    cStrArr.push(path ? `; path=${path}` : '');
    cStrArr.push(domain ? `; domain=${domain}` : '');
    cStrArr.push(secure ? '; secure' : '');

    document.cookie = cStrArr.join('');
};

/**
 * @returns {Array} 返回一个数组 [{name(cookie 名称), value(cookie 值)}]
 */
const getAll = function getAll() {
    const result = [];

    if (document.cookie !== '') {
        return document.cookie.split(';').map(item => {
            const a = item.split('=');
            let value = a.slice(1).join('=');

            try {
                value = decodeURIComponent(value);
            } catch (error) {
                value = unescape(value);
            }

            return {
                name: a[0].trim(),
                value,
            };
        });
    }

    return result;
};

/**
 * 获取单个cookie
 * @param {String} name cookie 名称
 * @returns {String} 返回cookie值，如果没有该cookie，返回空字符串
 */
const get = function get(name) {
    const cookies = getAll();

    for (const cookie of cookies) {
        if (cookie.name === name) {
            return cookie.value;
        }
    }

    return '';
};

/**
 * 删除cookie
 * @param {String} name cookie 名称
 * @param {String} path cookie 路径
 * @param {String} domain cookie 的域
 */
const del = function del(name, path, domain) {
    const cStrArr = [];
    const date = new Date();

    date.setTime(date.getTime() - 1000);

    cStrArr.push(`${name}=`);
    cStrArr.push(path ? `; path=${path}` : '');
    cStrArr.push(domain ? `; domain=${domain}` : '');
    cStrArr.push(`;expires=${date.toGMTString()}`);
    document.cookie = cStrArr.join('');
};

export default {
    get,
    set,
    setByEscape,
    del,
};
